import { medialUrl } from "../../../EndPoints";

import ElCorteLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/edcorte.png";
import SferaLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/sfera.png";
import TaoLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/tao.png";
import PiazaItaliaLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/piaza.png";
import OfftexLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/offtex.png";
import PuntoromaLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/punt-roma.png";
import SoulcalLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/soulcal.png";
import ManUtdLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/manunited.png";
import EsotiqLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/esotiq.png";
import LiveraLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/livera.png";
import BouLogo from "../../../assets/images/sister-concern/bd-knit-design/logos/boux.png";

import OuterImg from "../../../assets/images/sister-concern/bd-knit-design/outer-img.png";
import KnitPrintImg from "../../../assets/images/sister-concern/bd-knit-design/knit-print.png";
import KnitKittingImg from "../../../assets/images/sister-concern/bd-knit-design/knit-knitting.png";
import PrintingImg from "../../../assets/images/sister-concern/bd-knit-design/printing.png";

export const heroBDKnitImage = `${medialUrl}/img/SisterConcern/HeroSisterConcern1.png`;
export const associateBusinessBDKnit = {
  title: "Our Products",
  outerImage: OuterImg,
  arr: [
    {
      img: KnitPrintImg,
      innerTitle: "BD KNIT PRINT",
    },
    {
      img: KnitKittingImg,
      innerTitle: "BD KNIT KNITTING",
    },
    {
      img: PrintingImg,
      innerTitle: "BD PRINTING & EMBROIDERY",
    },
  ],
};

export const OurCustomersBDKnitImages = [
  [ElCorteLogo, SferaLogo, TaoLogo, PiazaItaliaLogo, OfftexLogo, PuntoromaLogo],
  [SoulcalLogo, ManUtdLogo, EsotiqLogo, LiveraLogo, BouLogo],
];
